$(document).ready(function(){

  // -- toggle burger menu --
  let menusWrapperHeight = 0;
  const animMenusBoxVl = document.getElementById('anim-menus-box-vl');
  const calculateMenusBoxVl = function() {
    menusWrapperHeight = document.getElementById('menus__wrapper').offsetHeight - 130 + 'px';
    animMenusBoxVl.style.height = menusWrapperHeight;
  }
  calculateMenusBoxVl();
  ['resize', 'orientationchange'].forEach(function(event){
    window.addEventListener(event, (e) => {
      calculateMenusBoxVl();
    });
  });


  $('.btn--menu').on('click', function(){
    // -- toggle active state --
    $(this).toggleClass('is-active');
    $('body').toggleClass('mainMenu--open');
    // -- toggle timeline state --
    tlMenus.reversed(!tlMenus.reversed());
  }); 


  // -- close menu when click outside div --
  $(document).mouseup(function(e){
    var container = $(".header");
    if (!container.is(e.target) && container.has(e.target).length === 0){
      $('.btn--menu').removeClass('is-active');
      $('body').removeClass('mainMenu--open');
    }
  });


  // -- multiple level menu --
  $('.mainMenu .dropdown').on('click', function(e){
    e.preventDefault();
    if ($(this).parent('li').hasClass('open')) {
      $('.mainMenu li').removeClass('open');
    } else {
      $('.mainMenu li').removeClass('open');
      $(this).parent('li').addClass('open')
    }
  });

});

// -- hide header on scroll down --
// (https://codingreflections.com/hide-header-on-scroll-down)
(function(){

  var doc = document.documentElement;
  var w = window;

  var prevScroll = w.scrollY || doc.scrollTop;
  var curScroll;
  var direction = 0;
  var prevDirection = 0;

  var header = document.getElementById('header');

  var checkScroll = function() {

    /*
    ** Find the direction of scroll
    ** 0 - initial, 1 - up, 2 - down
    */

    curScroll = w.scrollY || doc.scrollTop;
    if (curScroll > prevScroll) { 
      //scrolled up
      direction = 2;
    }
    else if (curScroll < prevScroll) { 
      //scrolled down
      direction = 1;
    }

    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }

    prevScroll = curScroll;
  };

  var toggleHeader = function(direction, curScroll) {
    if (direction === 2 && curScroll > header.offsetHeight) { 
      header.classList.add('hide');
      prevDirection = direction;
    }
    else if (direction === 1) {
      header.classList.remove('hide');
      prevDirection = direction;
    }
  };

  window.addEventListener('scroll', checkScroll);

})();